@let isInitialized = (authService.isInitialized());
@if (isInitialized) {
  @let isAuthenticated = (authService.isAuthenticated());

  <div *ngIf="isAuthenticated">
    <button (click)="logout()">Sign Out</button>
    <router-outlet></router-outlet>
  </div>
  <router-outlet *ngIf="!isAuthenticated"></router-outlet>
}
